import React, { useState } from "react";
import { ProductItem } from "../../../utils/Customer/CustomerTypes";

import ProductCard from "../../../components/Admin/ProductCard";
import ProductSelectorDropdown from "../../../components/Admin/ProductSelectorDropdown";
import Dropdown, { Option } from "../../../components/customer/Dropdown";
import { ChevronDown } from "lucide-react";
import { userTypeOptions } from "../../../utils/Customer/CustomerData";
import TextInputComp from "../../../components/customer/TextInputComp";
import { JoseraFinal } from "../../../utils/Customer/products";

const AdminCreateFreeProductScreen: React.FC = () => {

    const [selectedProduct, setSelectedProduct] =
        useState<ProductItem | null>(null);

    const [openDropdown, setOpenDropdown] =
        useState(false);

    const [userType, setUserType] = useState<Option | null>(null)

    const [cartAmount, setCartAmount] =
        useState("");

    return (
        <div className="p-5">

            {/* HEADER */}
            <div className="pb-6">
                <h1 className="text-2xl font-bold text-logoHeading">
                    Create Free Product
                </h1>

                <p className="text-sm text-gray-500 mt-1">
                    Create, update and manage free product.
                </p>
            </div>

            {/* TOP SECTION */}
            <div className="flex flex-col lg:flex-row justify-between items-start">

                {/* PRODUCT CARD */}
                <ProductCard
                    title="Select Free Product"
                    product={selectedProduct}
                    onClick={() => setOpenDropdown(true)}
                    onRemove={() => setSelectedProduct(null)}
                />

                <div className="w-full lg:w-[250px] rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">

                    <p className="text-sm font-medium mb-3">
                        User Type
                    </p>

                    {/* USER TYPE */}
                    <Dropdown
                        options={userTypeOptions}
                        value={userType}
                        onChange={setUserType}
                        className="w-full"
                        dropdownIcon={<ChevronDown size={16} />}
                    />

                </div>

                {/* CART PRICE */}
                <div className="w-full lg:w-[300px] rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">

                    <p className="text-sm font-medium mb-3">
                        Minimum Cart Price
                    </p>

                    <TextInputComp
                        type="number"
                        placeholder="Enter Cart Amount"
                        value={cartAmount}
                        onChangeText={setCartAmount}
                    />

                    <p className="text-xs text-gray-500 mt-2">
                        Customer will get this product free if cart value exceeds this amount.
                    </p>

                </div>

            </div>

            {/* PRODUCT DROPDOWN */}
            {/* <ProductSelectorDropdown
                open={openDropdown}
                products={JoseraFinal}
                placeholder="Search Free Product"
                onSelect={(product) => {
                    setSelectedProduct(product);
                    setOpenDropdown(false);
                }}
            /> */}

        </div>
    );
}

export default AdminCreateFreeProductScreen;